module.exports = __webpack_public_path__ + "static/media/Instagram.9015eb34.svg";